import api from '@/modules/api.service';
import { LotacaoService } from '@/modules/business/lotacoes/lotacao.service';
import { ReadLotacaoDto } from '@/api.types';

export async function buscarTodasLotacoesDefensorUseCase(defensorId: number): Promise<ReadLotacaoDto[]> {
  try {
    const response = await api.get(`/lotacao/by-defensor/${defensorId}`);
    return response.data || [];
  } catch (error) {
    console.error('Erro ao buscar lotações do defensor (novo endpoint):', error);

    try {
      const lotacaoService = new LotacaoService();
      const [lotacoes] = await lotacaoService.Enumerate({
        id_defensor: defensorId,
        skip: 0,
        take: 1000,
      } as any);

      return lotacoes || [];
    } catch (fallbackError) {
      console.error('Erro ao buscar lotações do defensor (fallback):', fallbackError);
      return [];
    }
  }
}
